import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import useR05Api from '../../api/useR05Api';
import { isComboTicket, isReserveTicket } from '../../utils';
import useReservationTicket from '../../hooks/useReservationTicket';
import styles from './styles.module.css';

const ReceiveEditReservationScreen = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { fetchOrderDetail } = useR05Api();
    const { prepareReservationEdit } = useReservationTicket();
    const { t } = useTranslation();

    useEffect(() => {
        const orderId = searchParams.get('orderId');
        const orderTicketId = searchParams.get('orderTicketId');

        if (!orderId) {
            navigate('/bought', { replace: true });
            return;
        }

        void (async () => {
            try {
                let orderTicket = await fetchOrderDetail({
                    orderId: orderId,
                    orderTicketId: orderTicketId !== '' ? orderTicketId : null,
                });
                // 販売チケット名のキーを分離
                orderTicket = {
                    ...orderTicket,
                    saleTicketName: orderTicket?.ticketName,
                    isReserve: isReserveTicket(orderTicket),
                };
                //子券・単券の場合
                if (!isComboTicket(orderTicket)) {
                    orderTicket = {
                        ...orderTicket,
                        ...(orderTicket.comboItems.length > 0 ? orderTicket.comboItems[0] : {}),
                    };
                }

                const success = await prepareReservationEdit(orderTicket);
                if (success) {
                    navigate(`/buy/reservation/confirm`, { replace: true });
                } else {
                    navigate('/bought', { replace: true });
                }
            } catch (error) {
                console.error('Error editing reservation:', error);
                navigate('/bought', { replace: true });
            }
        })();
    }, [searchParams, navigate, fetchOrderDetail, prepareReservationEdit]);
    return <div className={styles.loadingTitle}>{t('loading.small-bought-ticket')}</div>;
};

export default ReceiveEditReservationScreen;
